import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "",
        "subscriptionUrl": "",
        "assetDirectory": "/",
        "title": "Twenty Twenty",
        "description": "",
        "shortTitle": "Twenty Twenty",
        "appKey": "96c4e0bf-f73a-4719-ab1b-e572a83d0bfa",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "",
        "buildNumber": 237645,
        "buildDate": "2026-04-27T14:55:38.247Z",
        "version": "2.11.1"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": false,
            "type": "cognito",
            "config": {
                "host": "",
                "clientId": "",
                "customerPortalUrl": null
            }
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "basic",
            "config": {
                "sections": false
            }
        },
        "menu": {
            "links": []
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    }
};
export default config;